var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "message-ai-container flex",
      style: { "padding-right": _vm.isFullScreen() ? "0" : "32px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex",
          style: {
            width: !!_vm.text && !_vm.getIsShowImageGeneration ? "100%" : "",
          },
        },
        [
          _vm.isFullScreen()
            ? _c("div", [
                !!_vm.getHeadeImg.icon
                  ? _c("img", {
                      staticClass: "ai-head",
                      attrs: { src: _vm.getHeadeImg.icon, alt: "" },
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "ai-head-title-span",
                        style: {
                          background: _vm.getHeadeImg.backgroundColor,
                        },
                      },
                      [
                        _c(
                          "span",
                          { style: { color: _vm.getHeadeImg.textColor } },
                          [_vm._v(_vm._s(_vm.getHeadeImg.title.split("")[0]))]
                        ),
                      ]
                    ),
              ])
            : _vm._e(),
          _c("div"),
          _c(
            "div",
            {
              ref: "content",
              staticClass: "content",
              on: { mousedown: _vm.allowTextSelection },
            },
            [
              !_vm.getIsShowImageGeneration && !_vm.getIsShowHotspot
                ? [
                    _vm.newsName
                      ? _c(
                          "div",
                          {
                            staticClass: "think-content",
                            on: { click: _vm.openNewsList },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "thinking-head flex justify-center",
                                staticStyle: {
                                  "margin-bottom": "8px",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("p", { staticClass: "flex items-center" }, [
                                  _vm.parseString(_vm.newsName).iconVal
                                    ? _c("img", {
                                        staticStyle: {
                                          width: "16px",
                                          height: "16px",
                                          "margin-right": "8px",
                                        },
                                        attrs: {
                                          src: require(`@/assets/image/aigc/${
                                            _vm.parseString(_vm.newsName)
                                              .iconVal
                                          }.png`),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.parseString(_vm.newsName).text) +
                                      " "
                                  ),
                                  _vm.hasNewList
                                    ? _c("i", {
                                        staticClass: "el-icon-arrow-right",
                                        staticStyle: { "margin-left": "10px" },
                                      })
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    false
                      ? _c(
                          "div",
                          { staticClass: "think-content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "thinking-head flex justify-center align-center",
                                staticStyle: { "margin-bottom": "8px" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "flex items-center",
                                    on: {
                                      click: function ($event) {
                                        _vm.visibleThinkTxt =
                                          !_vm.visibleThinkTxt
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "16px",
                                        height: "16px",
                                        "margin-right": "8px",
                                      },
                                      attrs: {
                                        src: require("@/assets/image/aigc/think-icon.png"),
                                      },
                                    }),
                                    _vm._v(_vm._s(_vm.thinkTitle) + " "),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                      class: _vm.visibleThinkTxt
                                        ? "active"
                                        : "",
                                      staticStyle: { "margin-left": "10px" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c("VueMarkdown", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.visibleThinkTxt,
                                  expression: "visibleThinkTxt",
                                },
                              ],
                              staticClass: "think-markdown",
                              staticStyle: {
                                "font-size": "14px",
                                color: "#979797",
                              },
                              attrs: {
                                "message-id": _vm.messageId,
                                source: _vm.thinkingTxt,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.text,
                            expression: "text",
                          },
                        ],
                        staticClass: "text-content",
                      },
                      [
                        _c("VueMarkdown", {
                          attrs: {
                            source: _vm.text,
                            "citations-data": _vm.localCitationsData,
                            "message-id": _vm.messageId,
                          },
                        }),
                        _vm.tmpIsOk && _vm.source === "KNOWLEDGE"
                          ? _c("span", { staticClass: "source-tips" }, [
                              _vm._v(" " + _vm._s(_vm.sourceMsg) + " "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    !_vm.text
                      ? _c(
                          "div",
                          {
                            staticClass: "flex flex-middle",
                            staticStyle: { "margin-top": "10px" },
                          },
                          [
                            _vm.getIsShowDouyinBZhangGuide &&
                            !!_vm.videoLoadText
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "8px",
                                      display: "block",
                                      "min-width": "100px",
                                      color: "#313233",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.videoLoadText) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("img", {
                              staticClass: "loading",
                              attrs: {
                                src: require("@/assets/image/aigc/icon_loading.png"),
                                alt: "",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._t("custom"),
                    _vm.tmpIsOk &&
                    _vm.text !== "没有提取到文案！请检查下原视频。" &&
                    _vm.text !== "链接内容无法提取" &&
                    _vm.text !== "视频无法获取！" &&
                    _vm.text !== "视频时长超过20分钟，无法处理!"
                      ? _c("div", { ref: "floatOp", staticClass: "float-op" }, [
                          _c("div", { staticClass: "flex flex-middle" }, [
                            _c(
                              "div",
                              {
                                staticClass: "float-tools",
                                style: {
                                  "margin-right": "14px",
                                },
                                on: { click: _vm.copyText },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-default",
                                  attrs: {
                                    src: require("@/assets/image/aigc/copy.png"),
                                    alt: "",
                                  },
                                }),
                                _c("img", {
                                  staticClass: "img-hover",
                                  attrs: {
                                    src: require("@/assets/image/aigc/copy-hover.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "tip" }, [
                                  _vm._v("复制"),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "float-tools",
                                style: {
                                  "margin-right": "14px",
                                  "pointer-events":
                                    _vm.isLike || _vm.isNoLike ? "none" : "",
                                },
                                on: { click: _vm.likeSave },
                              },
                              [
                                _vm.isLike
                                  ? _c("img", {
                                      staticClass: "img-hover",
                                      staticStyle: { display: "block" },
                                      attrs: {
                                        src: require("@/assets/image/aigc/ok-like.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                !_vm.isLike
                                  ? _c("img", {
                                      staticClass: "img-default",
                                      attrs: {
                                        src: require("@/assets/image/aigc/like-s.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                !_vm.isNoLike && !_vm.isLike
                                  ? _c("img", {
                                      staticClass: "img-hover",
                                      attrs: {
                                        src: require("@/assets/image/aigc/like.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "tip",
                                    staticStyle: { left: "-9px" },
                                  },
                                  [_vm._v("喜欢")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "float-tools",
                                style: {
                                  "margin-right": "14px",
                                  "pointer-events":
                                    _vm.isNoLike || _vm.isLike ? "none" : "",
                                },
                                on: { click: _vm.noLikeSave },
                              },
                              [
                                _vm.isNoLike
                                  ? _c("img", {
                                      staticClass: "img-hover",
                                      staticStyle: { display: "block" },
                                      attrs: {
                                        src: require("@/assets/image/aigc/ok-no-like.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                !_vm.isNoLike
                                  ? _c("img", {
                                      staticClass: "img-default",
                                      attrs: {
                                        src: require("@/assets/image/aigc/noLike-s.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                !_vm.isNoLike && !_vm.isLike
                                  ? _c("img", {
                                      staticClass: "img-hover",
                                      attrs: {
                                        src: require("@/assets/image/aigc/noLike.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "tip",
                                    staticStyle: { left: "-18px" },
                                  },
                                  [_vm._v("不喜欢")]
                                ),
                              ]
                            ),
                            _vm.getIsShowDouyinBZhangGuide &&
                            _vm.text !== "没有提取到文案！请检查下原视频。" &&
                            _vm.text !== "链接内容无法提取" &&
                            _vm.text !== "视频无法获取！" &&
                            _vm.text !== "视频时长超过20分钟，无法处理!"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "float-tools",
                                    on: { click: _vm.openRevision },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-default",
                                      attrs: {
                                        src: require("@/assets/image/aigc/gaigao.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c("img", {
                                      staticClass: "img-hover",
                                      attrs: {
                                        src: require("@/assets/image/aigc/gaigao-hover.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "title-span title-span-gaigao",
                                      },
                                      [_vm._v("AI改稿")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.getIsShowDouyinBZhangGuide &&
                            _vm.text !== "没有提取到文案！请检查下原视频。" &&
                            _vm.text !== "链接内容无法提取" &&
                            _vm.text !== "视频无法获取！" &&
                            _vm.text !== "视频时长超过20分钟，无法处理!"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "float-tools",
                                    on: {
                                      click: function ($event) {
                                        return _vm.createTopic(_vm.text)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-default",
                                      attrs: {
                                        src: require("@/assets/image/aigc/scxtg.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c("img", {
                                      staticClass: "img-hover",
                                      attrs: {
                                        src: require("@/assets/image/aigc/scxtg.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "title-span title-span-xtg",
                                      },
                                      [_vm._v("生成选题稿")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.getIsShowImageGeneration
                ? [
                    !_vm.imgError
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: !_vm.text,
                                expression: "!text",
                              },
                            ],
                            class: {
                              "image-generation-row": true,
                              "image-generation-row-slide": !_vm.isFullScreen(),
                            },
                            style: {
                              background: !_vm.text
                                ? "linear-gradient(180deg,#fceffc 0%,#d3dcff 52%,#dff8ff 100%)"
                                : "",
                            },
                            attrs: {
                              "element-loading-background": "rgba(0, 0, 0, 0)",
                            },
                          },
                          [
                            !_vm.text
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "percentage-span",
                                    style: {
                                      "font-size": _vm.isFullScreen()
                                        ? "20px"
                                        : "16px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.progressValue) + "% "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.text
                              ? _c("el-progress", {
                                  staticClass: "percentage-j",
                                  attrs: {
                                    percentage: _vm.progressValue,
                                    "show-text": false,
                                  },
                                })
                              : _vm._e(),
                            !_vm.text
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "percentage-title",
                                    style: {
                                      "font-size": _vm.isFullScreen()
                                        ? "16px"
                                        : "14px",
                                    },
                                  },
                                  [_vm._v(" AI生成中 ")]
                                )
                              : _vm._e(),
                            !!_vm.text &&
                            (_vm.text.includes("https") ||
                              _vm.text.includes("http")) &&
                            _vm.getIsShowImageGeneration
                              ? _c(
                                  "ImageCustom",
                                  {
                                    staticClass: "generation-image",
                                    attrs: {
                                      src: _vm.text,
                                      "preview-src-list": [_vm.text],
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.tmpIsOk
                              ? _c(
                                  "div",
                                  { ref: "floatOp", staticClass: "float-op" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-middle" },
                                      [
                                        !_vm.isHistory && !_vm.imgError
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "float-tools",
                                                on: { click: _vm.resetAnswer },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-default",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/r-hover.png"),
                                                    alt: "",
                                                  },
                                                }),
                                                _c("img", {
                                                  staticClass: "img-hover",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/r-hover.png"),
                                                    alt: "",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "title-span title-span-reset",
                                                  },
                                                  [_vm._v("重新生成")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.imgError
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "float-tools",
                                                on: { click: _vm.downloadImg },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-default",
                                                  staticStyle: {
                                                    "margin-right": "0",
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/download-hover.png"),
                                                    alt: "",
                                                  },
                                                }),
                                                _c("img", {
                                                  staticClass: "img-hover",
                                                  staticStyle: {
                                                    "margin-right": "0",
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/download-hover.png"),
                                                    alt: "",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "title-span title-span-down",
                                                  },
                                                  [_vm._v("下载")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-middle flex-right",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "float-tools",
                                            style: {
                                              "margin-right": "14px",
                                              "pointer-events":
                                                _vm.isLike || _vm.isNoLike
                                                  ? "none"
                                                  : "",
                                            },
                                            on: { click: _vm.likeSave },
                                          },
                                          [
                                            _vm.isLike
                                              ? _c("img", {
                                                  staticClass: "img-hover",
                                                  staticStyle: {
                                                    display: "block",
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/ok-like.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.isLike
                                              ? _c("img", {
                                                  staticClass: "img-default",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/like-s.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.isNoLike && !_vm.isLike
                                              ? _c("img", {
                                                  staticClass: "img-hover",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/like.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "tip",
                                                staticStyle: { left: "-9px" },
                                              },
                                              [_vm._v("喜欢")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "float-tools",
                                            style: {
                                              "margin-right": "0",
                                              "pointer-events":
                                                _vm.isNoLike || _vm.isLike
                                                  ? "none"
                                                  : "",
                                            },
                                            on: { click: _vm.noLikeSave },
                                          },
                                          [
                                            _vm.isNoLike
                                              ? _c("img", {
                                                  staticClass: "img-hover",
                                                  staticStyle: {
                                                    display: "block",
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/ok-no-like.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.isNoLike
                                              ? _c("img", {
                                                  staticClass: "img-default",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/noLike-s.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.isNoLike && !_vm.isLike
                                              ? _c("img", {
                                                  staticClass: "img-hover",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/noLike.png"),
                                                    alt: "",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "tip",
                                                staticStyle: { left: "-18px" },
                                              },
                                              [_vm._v("不喜欢")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c("p", [_vm._v(_vm._s(_vm.imgError))]),
                  ]
                : _vm._e(),
              _vm.getIsShowHotspot ? void 0 : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }